<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <b-img
          fluid
          src="@/assets/images/logo/Udara360-logo.png"
          width="180"
        />
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5 image-appearance"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <!-- <b-img
            fluid
            src="@/assets/images/logo/boi-logo.png"
            alt="Login V2"
            width="600"
          />
        </div> -->
          <b-img
            v-if="institution"
            fluid
            :src="institution.loginPageBackgroundURL"
            alt="Institution logo"
            width="600"
          />
        </div></b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title class="mb-1">
            Reset Password 🔒
          </b-card-title>
          <b-card-text class="mb-2">
            Your new password must be different from previously used passwords
          </b-card-text>

          <Alert
            :show="showFormError"
            :message="errorMessage"
          />

          <!-- form -->
          <validation-observer ref="changePasswordForm">
            <b-form>
              <b-row>
                <!-- new password -->
                <b-col md="12">
                  <InputPasswordField
                    id="new-password"
                    v-model="userDetails.newPassword"
                    label="New Password"
                    placeholder="New Password"
                    error-name="new password"
                    rules="required|min:6|upperCaseChar|lowerCaseChar|numberVal|specialChar"
                    vid="newPassword"
                  />
                </b-col>
                <!--/ new password -->

                <!-- retype password -->
                <b-col md="12">
                  <InputPasswordField
                    id="retype-password"
                    v-model="userDetails.confirmNewPassword"
                    label="Retype Password"
                    placeholder="Retype Password"
                    error-name="retype password"
                    rules="required|confirmed:newPassword"
                  />
                </b-col>
              </b-row>
              <!--/ retype password -->

              <!-- submit button -->
              <b-row class="m-1">
                <Button
                  label="Save"
                  size="lg"
                  block
                  :loading="isLoading"
                  :disabled="isDisabled"
                  @click="changeUserPassword"
                />
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="reset"
                  variant="outline-secondary"
                  class="ml-1"
                >
                  Cancel
                </b-button>
                <!--/ buttons -->
              </b-row>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ChevronLeftIcon" /> Back to login
            </b-link>
          </b-card-text>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationObserver } from 'vee-validate'
import {
  BButton, BRow, BCol, BLink, BCardText, BCardTitle, BImg, BForm,
} from 'bootstrap-vue'
import { required } from '@validations'
import { mapActions, mapGetters } from 'vuex'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { toastAlert } from '@core/mixins/toast'
import InputPasswordField from '../../forms/InputPasswordField.vue'
import Button from '../../components/button/Button.vue'
import Alert from '../../components/alert/Alert.vue'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BLink,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    ValidationObserver,
    InputPasswordField,
    Button,
    Alert,
  },
  mixins: [toastAlert, sweetAlert],
  data() {
    return {
      userDetails: {
        newPassword: '',
        confirmNewPassword: '',
      },
      email: '',
      isLoading: false,
      isDisabled: false,
      showFormError: false,
      errorMessage: '',
      required,
    }
  },
  computed: {
    ...mapGetters({
      institution: 'auth/getInstitution',
    }),
  },
  watch: {
    hasResentToken(newValue) {
      if (newValue) {
        // eslint-disable-next-line no-return-assign
        setTimeout(() => (this.hasResentToken = false), 1000 * 3)
      }
    },
  },
  mounted() {
    this.getUser()
  },
  methods: {
    ...mapActions({
      changePasswordWithoutQuestion: 'auth/changePasswordWithoutQuestion',
    }),
    getUser() {
      const { user } = this.$route.params
      if (user) {
        this.email = user
      } else {
        this.$router.push({ name: 'auth-forgot-password' })
      }
    },
    changeUserPassword() {
      this.$refs.changePasswordForm.validate().then(async success => {
        if (success) {
          try {
            this.showFormError = false
            this.isDisabled = true
            this.isLoading = true
            await this.changePasswordWithoutQuestion({
              ...this.userDetails,
              email: this.email,
            })
              .then(() => {
                this.$router
                  .push({ name: 'auth-login' })
                this.toastAlert({
                  title: 'Success',
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: 'You have successfully changed your password',
                })
              })
            this.isDisabled = false
            this.isLoading = false

            return true
          } catch (error) {
            this.showFormError = true
            error.response.data.errors.forEach(responseError => {
              this.errorMessage = responseError.errorMessage
            })
          } finally {
            this.isDisabled = false
            this.isLoading = false
          }
        }
        return false
      })
    },
  },
}
</script>
<style scoped>
.image-appearance {
  opacity: 0.5;
}
</style>
<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
